import { Hint, type HintPopoverPositions } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface IAddProjectHintProps {
  stepNumber: number
  position?: HintPopoverPositions
  children?: React.ReactNode
}

const AddProjectHint = ({
  stepNumber,
  position = 'bottom left',
  children,
}: IAddProjectHintProps) => {
  return (
    <Hint.Popover
      step={stepNumber}
      title={i18n.t('project_management.my_projects.hints.add_project.title')}
      description={i18n.t('project_management.my_projects.hints.add_project.description')}
      actionLabel={i18n.t('project_management.my_projects.hints.add_project.action_label')}
      position={position}
    >
      {children}
    </Hint.Popover>
  )
}

export default observer(AddProjectHint)
